import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

import {
    Row,
    Title,
    Button,
} from 'yurstrap';

import {
    acceptAllCookies,
    refuseAllCookies,
} from '../reduxModules/ConsentManagementPlatform';

const propTypes = {
    AppActions: PropTypes.shape({
        acceptAllCookies: PropTypes.func.isRequired,
        refuseAllCookies: PropTypes.func.isRequired,
    }).isRequired,
};

export class CMPHeader extends Component {

    constructor(props) {
        super(props);
        this.onClickAcceptAll = this.onClickAcceptAll.bind(this);
        this.onClickRefuseAll = this.onClickRefuseAll.bind(this);
    }

    onClickAcceptAll() {
        const { AppActions } = this.props;
        AppActions.acceptAllCookies();
    }

    onClickRefuseAll() {
        const { AppActions } = this.props;
        AppActions.refuseAllCookies();
    }

    render() {
        return (
            <>
                <Row noCol>
                    <Title
                        componentClass="h2"
                    >
                        Gestion de vos préférences sur les cookies
                    </Title>
                    Certains cookies sont nécessaires au bon fonctionnement du site
                    (exemple: pour la connexion ou le maintien de la session utilisateur),
                    tandis que d'autres servent les objectifs listés ci-dessous.
                    Pour chacun de ces cookies/traceurs déposés par Yurplan et ses
                    partenaires vous trouverez une description détaillée de ses objectifs
                    et pourrez librement choisir son activation.
                    Vous restez maître de vos données personnelles.
                </Row>
                <div
                    className="mt-4"
                >
                    <Button
                        color="secondary"
                        onClick={this.onClickRefuseAll}
                    >
                        Tout refuser
                    </Button>
                    <Button
                        color="premium"
                        className="c-btn--premium u-display__b--s mt--s-3"
                        onClick={this.onClickAcceptAll}
                    >
                        Tout accepter
                    </Button>
                </div>
            </>
        );
    }

}

CMPHeader.propTypes = propTypes;

function mapDispatchToProps(dispatch) {
    return {
        AppActions: bindActionCreators({
            acceptAllCookies,
            refuseAllCookies,
        }, dispatch),
    };
}

export default connect(undefined, mapDispatchToProps)(CMPHeader);
